"use client"

import { useState, useContext, useEffect, useRef } from "react"
import { ErpContext } from "../../context/ErpContext.js"

import {
  IconButton,
  TextField,
  Button,
  Autocomplete,
  Collapse,
  Modal,
  Typography,
  Box,
  Grid,
  Divider,
  Stack,
  Tooltip,
  Card,
  CardContent,
  alpha,
} from "@mui/material"


import { Close as CloseIcon } from "@mui/icons-material"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import { red } from "@mui/material/colors"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import DeleteIcon from "@mui/icons-material/Delete"
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt"
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart"
import ReceiptIcon from "@mui/icons-material/Receipt"
import PersonIcon from "@mui/icons-material/Person"
import SearchIcon from "@mui/icons-material/Search"
import PaymentIcon from "@mui/icons-material/Payment"
import dayjs from "dayjs"

import "./GestionGenerarVentaComponent.css"

import { styled } from "@mui/material/styles"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"

import ModalFacturaComponent from "./ModalFacturaComponent.js"
import ModalEntidadCliente from "../adminComponent/ModalEntidadClienteComponent.js"
import CrearEntidadClienteModalComponent from "../adminComponent/CrearEntidadClienteModalComponent.js"
import SpinnerLading from "../misc/SpinnerComponent.js"

import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const MySwal = withReactContent(Swal)

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#5b5b5f",
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.1),
    transition: "background-color 0.2s ease",
  },
  // Reducir la altura de las filas
  "& .MuiTableCell-root": {
    padding: "6px 8px", // Reducir padding vertical y horizontal
    height: "40px", // Altura fija más compacta
  },
}))

const GestionGenerarCompraComponent = ({ preloadedData, onClose, isModal }) => { // preloadedData: datos precargados desde inventary, onClose: cerrar modal, isModal: si es modal
  const {
    getItemTresLetras,
    itemTresLetras,
    postTransaccionItem,
    postTransaccion,
    getTipoEntidad,
    tipoEntidades,
    tipoMedioDePago,
    getTipoMedioDePago,
    updateItemUbicacion,
    postCrearPago,
    postTransaccionPago,
    getMedioDePagoIdTipoEspecifico,
    medioDePagoIdTipoEspecifico,
    getCuentaCorriente,
    getCuentaCorrienteByIdEntidad,
    postCuentaCorriente,
    updateCuentaCorriente,
    cuentasCorrientes,
    getItemUbicacionFilter,
    entidadesTipoEntidad,
    getEntidadByTipoEntidad,
    getUbicacion,
    ubicaciones,
    getNegocio,
    negocios,
    getItemUbicacionFilterByUbicacion,
    getListaMontosByIdItemIdEntidad,
    getPrecioLista,
    getEstadoCompra,
    postTransaccionCompraEstado,
    postTransaccionCompraItem,
    getFechaHoraActualClient, 
    isNavbarCollapsed,
    getEntidadByID,
    updateItemPrecioListaId,
    getEntidadesClientesTresLetras,
  } = useContext(ErpContext)

  const [descripcionTransaccion, setDescripcionTransaccion] = useState("")
  const [selectedItem, setSelectedItem] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [filteredItems, setFilteredItems] = useState([])
  const [itemList, setItemList] = useState([])
  const [dniProveedor, setDniProveedor] = useState("")

  const [precioTotal, setPrecioTotal] = useState(0)
  const [cantidadItemsSelect, setCantidadItemsSelect] = useState(0)
  const [cantidadItemsInvocados, setCantidadItemsInvocados] = useState(0)

  const [entidadExistente, setEntidadExistente] = useState(null)
  const [abrirModalCrearCliente, setAbrirModalCrearCliente] = useState(false)
  const [abrirModalEntidadCliente, setAbrirModalEntidadCliente] = useState(false)

  const [entidadAEditar, setEntidadAEditar] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [transaccionData, setTransaccionData] = useState(null)
  const [itemsTransaccion, setItemsTransaccion] = useState([])
  const [entidadFactura, setEntidadFactura] = useState([])

  /* LOGICA MODAL MEDIO DE PAGO*/
  const [openModalMedioPago, setOpenModalMedioPago] = useState(false)

  /*Variables Medio de pago*/
  const [modalMedioDePagoSeleccionadoID, setModalMedioDePagoSeleccionadoID] = useState(null)
  const [modalTipoMedioDePagoSeleccionado, setModalTipoMedioDePagoSeleccionado] = useState(null)
  const [modalMedioDePagoSeleccionado, setModalMedioDePagoSeleccionado] = useState(null)
  const [modalMedioDePagoCantidad, setModalMedioDePagoCantidad] = useState(null)
  const [medioDePagoList, setMedioDePagoList] = useState([])

  const [selectedTipoMedioDePago, setSelectedTipoMedioDePago] = useState(null)
  const [selectedMedioDePago, setSelectedMedioDePago] = useState([])
  const [openCollapse, setOpenCollapse] = useState(false)

  const [mostrarButtonModalMedioPago, setMostrarButtonModalMedioPago] = useState(false)

  const [cantidaMedioDePagoList, setCantidaMedioDePagoList] = useState(0)

  const [selectedUbicacion, setSelectedUbicacion] = useState(null)
  const [selectedNegocio, setSelectedNegocio] = useState(null)

  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(false)

  const [estadoDeCompra, setEstadoDeCompra] = useState([])

  const [successMessage, setSuccessMessage] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const [isLoadingPreloadedData, setIsLoadingPreloadedData] = useState(false)

  useEffect(() => {
    if (selectedTipoMedioDePago) {
      if (selectedTipoMedioDePago.id === 7) {
        setOpenCollapse(false)
        setMostrarButtonModalMedioPago(true)
        setOpenModalMedioPago(true)
      } else {
        getMedioDePagoIdTipoEspecifico(selectedTipoMedioDePago)
        setMostrarButtonModalMedioPago(false)
        setOpenCollapse(true)
      }
    } else {
      setOpenCollapse(false)
      setOpenModalMedioPago(false)
      setMedioDePagoList([])
    }

    if (modalTipoMedioDePagoSeleccionado) {
      getMedioDePagoIdTipoEspecifico(modalTipoMedioDePagoSeleccionado)
    }
  }, [selectedTipoMedioDePago, modalTipoMedioDePagoSeleccionado])

  useEffect(() => {
    setItemList([])
  }, [selectedUbicacion])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTipoEntidad()
        await getTipoMedioDePago()
        await getEntidadByTipoEntidad(2) // Cargar proveedores (tipo entidad 2)
        await getUbicacion()
        await getNegocio()
        //const estadoDeCompra = await getEstadoCompra()

        //setEstadoDeCompra(estadoDeCompra)

        // Configurar la ubicación predeterminada
        const defaultUbicacion = ubicaciones.find((it) => it.id === 1)
        const defaultNegocio = negocios.find((it) => it.id === 1)
        if (defaultUbicacion) {
          setSelectedUbicacion({
            id: defaultUbicacion.id,
            label: defaultUbicacion.descripcion,
          })
        }
        if (defaultNegocio) {
          setSelectedNegocio({
            id: defaultNegocio.id,
            label: defaultNegocio.descripcion,
          })
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error)
      }
    }

    fetchData()
  }, [])

  // Procesar datos precargados del inventario
  useEffect(() => {
    const processPreloadedData = async () => {
      if (preloadedData && preloadedData.selectedItems) {
        setIsLoadingPreloadedData(true) // estado de carga para datos precargados
        console.log("Procesando datos precargados:", preloadedData)
        
        // Establecer ubicación hardcodeada como 1
        const ubicacionHardcoded = ubicaciones.find(ub => ub.id === 1) // ubicación hardcodeada como 1, revisar ya que el precio puede variar según la ubicación
        if (ubicacionHardcoded) {
          setSelectedUbicacion({
            id: ubicacionHardcoded.id,
            label: ubicacionHardcoded.descripcion,
          })
        }

        // Establecer proveedor seleccionado usando getEntidadByID para obtener datos completos
        if (preloadedData.proveedor) { // si hay proveedor 
          const proveedorCompleto = await getEntidadByID(preloadedData.proveedor.id) // obtener proveedor completo
          if (proveedorCompleto) {
            // Crear el objeto en el formato que espera el Autocomplete
            const proveedorFormateado = {
              label: `${proveedorCompleto.descripcion} - ${proveedorCompleto.apellido} - ${proveedorCompleto.dniCuitCuil}`,
              descripcion: proveedorCompleto.descripcion,
              apellido: proveedorCompleto.apellido,
              id: proveedorCompleto.id,
              dniCuitCuil: proveedorCompleto.dniCuitCuil,
            }
            setDniProveedor(proveedorFormateado)
            setProveedorSeleccionado(true)
          }
        }

        // Procesar items seleccionados
        const processedItems = []
        for (const selectedItem of preloadedData.selectedItems) { // para cada item seleccionado
          try {
            console.log(`Procesando item ${selectedItem.idItem} con proveedor ${preloadedData.proveedor.id}...`)
            
            // Buscar información de precio usando ListaDeMontos (reemplaza itemEntidad deprecado)
            const precioListaItem = await getListaMontosByIdItemIdEntidad(
              preloadedData.proveedor.id, 
              selectedItem.idItem, 
              1 // ubicación hardcodeada
            )
            console.log("precioListaItem:", precioListaItem)

            // Buscar información de ubicación para este item (solo para stock)
            const ubicacionItem = await getItemUbicacionFilterByUbicacion(selectedItem.idItem, 1)
            console.log("ubicacionItem:", ubicacionItem)
            

            if (ubicacionItem && ubicacionItem.length > 0) {
              const itemData = ubicacionItem[0]
              console.log("itemData:", itemData)
              
              // Obtener el costo desde ListaDeMontos o usar 0 como fallback
              const costoItem = precioListaItem ? precioListaItem.monto : 0
              
              // Crear objeto para itemList
              const newItem = {
                id: selectedItem.id,
                idItem: selectedItem.idItem,
                codigo: selectedItem.codigo,
                descripcion: selectedItem.descripcion,
                cantidad: 1, // Cantidad por defecto
                costo: costoItem,
                subtotal: costoItem,
                stock: itemData.inventario,
                stockMinimo: itemData.stockMinimo,
                ubicacion: itemData.ubicacion,
                // Datos adicionales que podrían ser útiles
                itemOriginal: selectedItem,
                precioData: precioListaItem, // Reemplaza proveedorData
                ubicacionData: itemData,
              }

              console.log("newItem:", newItem)
              
              processedItems.push(newItem)
            }
          } catch (error) {
            console.error(`Error procesando item ${selectedItem.idItem}:`, error)
          }
        }

        // Establecer la lista de items procesados
        setItemList(processedItems)
        console.log("Items procesados y agregados a itemList:", processedItems)
        
        setIsLoadingPreloadedData(false)
      }
    }

    // Solo procesar si ya tenemos los datos necesarios cargados
    if (preloadedData && ubicaciones.length > 0) {
      processPreloadedData()
    }
  }, [preloadedData, ubicaciones])

  // useEffect para manejar la lógica de búsqueda con selección automática
  useEffect(() => {
    if (searchText.length >= 3) {
      getItemTresLetras(searchText)
      // Agregar item automáticamente si se puede
      agregarItemRapido()
    } else {
      setFilteredItems([])
    }
  }, [searchText])

  const agregarItemRapido = async () => {
    await handleAddItem()
  }

  // useEffect para actualizar el total
  useEffect(() => {
    const updatedTotal = itemList.reduce((total, item) => total + item.cantidad * item.costo, 0)
    setPrecioTotal(updatedTotal)
  }, [itemList])

  const handleAbrirModalMedioDePago = () => {
    setOpenModalMedioPago(true)
  }

  const handleDeleteMedioDePago = (medioDePago, medioDePagoMonto) => {
    setCantidaMedioDePagoList((prevTotal) => prevTotal - medioDePagoMonto)
    setMedioDePagoList(medioDePagoList.filter((_, i) => i !== medioDePago))
  }

  const handleAddNuevoMedioDePago = () => {
    if (modalMedioDePagoSeleccionado && modalMedioDePagoCantidad) {
      const newMedioDePago = {
        id: modalMedioDePagoSeleccionadoID,
        descripcion: modalMedioDePagoSeleccionado,
        monto: Number.parseFloat(modalMedioDePagoCantidad),
        tipoMedioDePago: modalTipoMedioDePagoSeleccionado.id,
      }

      setMedioDePagoList([...medioDePagoList, newMedioDePago])

      const updatedTotalMedioPagoList = [...medioDePagoList, newMedioDePago].reduce(
        (total, item) => total + item.monto,
        0,
      )

      setCantidaMedioDePagoList(updatedTotalMedioPagoList)
      setModalMedioDePagoSeleccionado("")
      setModalMedioDePagoSeleccionadoID(null)
      setModalMedioDePagoCantidad("")
    }
  }

  const handleProveedorSeleccionado = (event, newValue) => {
    if (newValue) {
      setDniProveedor(newValue)
      setProveedorSeleccionado(true)
    } else {
      setDniProveedor(null)
      setProveedorSeleccionado(false)
      setSelectedItem(null)
    }
  }

  const handleTransaccionSubmit = async () => {
        const today = dayjs();
    
    try {
      // Validar costos antes de procesar
      const itemsConCostosInvalidos = itemList.filter(it => 
        it.cantidad && (isNaN(it.costo) || it.costo <= 0)
      );
      
      if (itemsConCostosInvalidos.length > 0) {
        const itemsInvalidos = itemsConCostosInvalidos.map(it => it.descripcion).join(', ');
        MySwal.fire({
          icon: "error",
          title: "Error",
          text: `Los siguientes items tienen costos inválidos: ${itemsInvalidos}`,
        });
        return;
      }
      // Crear la transacción
      const transaccionResponse = await postTransaccion(
        precioTotal,
        2, // idTipoTransaccion (2 para compras)
        dniProveedor.id,
        null, // idSubCategoriaTransaccion
        descripcionTransaccion,
        null, // idUsuario
        selectedUbicacion.id,
        selectedNegocio.id,
        0, // montoDescuento
        0, // porcentajeDescuento
      )

      setEntidadFactura(dniProveedor)

      const idTransaccion = transaccionResponse.data.id

      let suma = 0;

if (selectedTipoMedioDePago) {
  if (selectedTipoMedioDePago.id == 7) {
    // Procesar múltiples medios de pago
    for (const it of medioDePagoList) {
      const transaccionCrearPago = await postCrearPago(
        1, // idMoneda
        1, // cotizacion
        it.id, // idMedioPago
        it.monto // monto a pagar
      );

      suma += it.monto;

      // Manejar cuenta corriente si es necesario
      if (it.tipoMedioDePago == 5) {
        const cuentas = await getCuentaCorrienteByIdEntidad(dniProveedor.id);
        const cuentaCorrienteConId = cuentas.find(
          (ct) => ct.idEntidad === dniProveedor.id
        );
        if (cuentaCorrienteConId) {
          await updateCuentaCorriente(dniProveedor.id, it.monto, "compra");
        } else {
          await postCuentaCorriente(dniProveedor.id, it.monto, "compra");
        }
      }

      const idTransaccionCrearPago = transaccionCrearPago.data.id;
      await postTransaccionPago(idTransaccion, idTransaccionCrearPago);
    }

    // Una vez procesados todos los medios, verificar si la suma coincide con el precio total.
    if (suma === precioTotal) { 
      await postTransaccionCompraEstado(idTransaccion, 5); // SALDO CERRADO
    } else {
      await postTransaccionCompraEstado(idTransaccion, 1); // ABIERTO, falta pagar. 
    }
  } else if (selectedMedioDePago) {
    // Procesar único medio de pago
    const transaccionCrearPago = await postCrearPago(
      1, // idMoneda
      1, // cotizacion
      selectedMedioDePago.id,
      precioTotal
    );

    if (selectedTipoMedioDePago.id == 5) {
      const cuentas = await getCuentaCorrienteByIdEntidad(dniProveedor.id);
      const cuentaCorrienteConId = cuentas.find(
        (ct) => ct.idEntidad === dniProveedor.id
      );
      if (cuentaCorrienteConId) {
        await updateCuentaCorriente(dniProveedor.id, precioTotal, "compra");
      } else {
        await postCuentaCorriente(dniProveedor.id, precioTotal, "compra");
      }
    }

    const idTransaccionCrearPago = transaccionCrearPago.data.id;
    await postTransaccionPago(idTransaccion, idTransaccionCrearPago);

    // Como se utilizó un único medio de pago, se asume que la compra está saldada.
    await postTransaccionCompraEstado(idTransaccion, 5);
  }
  
}
else {
  await postTransaccionCompraEstado(idTransaccion, 1); // ABIERTO, falta pagar.
}

      // Crear los ítems asociados a la transacción y actualizar precios
      const costosActualizados = [];
      for (const it of itemList) {
        if (it.idItem && it.cantidad) {
          // Actualizar precio de lista para el proveedor
          try {
            await updateItemPrecioListaId(it.idItem, dniProveedor.id, it.idUbicacion, it.costo, "valor");
            costosActualizados.push(it.descripcion);
          } catch (error) {
            console.error(`Error actualizando costo para ${it.descripcion}:`, error);
          }

          // Crear el ítem asociado a la transacción
          await postTransaccionItem(
            idTransaccion,
            it.idItem,
            it.cantidad,
            it.costo,
            0, // porcentajeDescuento
          )

          await postTransaccionCompraItem(
            today,
            idTransaccion,
            it.idItem,
            0, //cantidad a analizar una vez este la transaccion.
          )
        }
      }

      // Preparar datos para el PDF
      let medioDePagoPDF = []
      if (selectedTipoMedioDePago) {
        if (selectedTipoMedioDePago.id != 7) {
          if (selectedMedioDePago) {
            const newMedioDePago = {
              id: selectedMedioDePago.id,
              descripcion: selectedMedioDePago.descripcion,
              monto: precioTotal,
              tipoMedioDePago: selectedMedioDePago.idTipoMedioDePago,
            }
            medioDePagoPDF = [newMedioDePago]
          }
        } else {
          medioDePagoPDF = medioDePagoList
        }
      }

      const transaccionData = {
        id: idTransaccion,
        cliente: dniProveedor.descripcion,
        tipoMedioDePago: selectedTipoMedioDePago ? selectedMedioDePago?.descripcion : "Sin medio de pago",
        montoDescuento: 0,
        pagos: medioDePagoPDF,
        porcentajeDescuento: 0,
        fecha: getFechaHoraActualClient,
      }

      setTransaccionData(transaccionData)
      setItemsTransaccion(itemList)

      // Abrir el modal
      setOpenModal(true)

      // Limpiar formulario
      setSelectedItem(null)
      setSearchText("")
      setItemList([])
      setDniProveedor("")
      setSelectedTipoMedioDePago(null)
      setSelectedMedioDePago(null)
      setMedioDePagoList([])
      setCantidaMedioDePagoList(0)

      // Mostrar mensaje de éxito
      let mensajeExito = "Compra generada correctamente";
      if (costosActualizados.length > 0) {
        mensajeExito += `. Costos actualizados para: ${costosActualizados.join(', ')}`;
      }
      
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "success",
        text: mensajeExito,
        showConfirmButton: false,
        timer: 5000, // Más tiempo si hay costos actualizados
        width: costosActualizados.length > 0 ? 400 : 300,
      })
    } catch (error) {
      console.error("Error al crear la transacción:", error)

      // Mostrar mensaje de error
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "error",
        text: "Error al generar la compra",
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      })
    }
    
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const crearVentaIgualmente = () => {
    handleTransaccionSubmit(false)
  }

  const handleAddItem = async () => {
    try {
      // Verifica que haya un ítem seleccionado
      if (selectedItem) {
        console.log(selectedItem)

        // Obtener la ubicación del ítem
        console.log(dniProveedor)
        console.log(selectedItem.id, dniProveedor.id)

        // Obtener el precio de lista según el proveedor seleccionado
        const precioListaItem = await getListaMontosByIdItemIdEntidad(
          dniProveedor.id,
          selectedItem.id,
          selectedUbicacion.id,
        )

        // Obtener información de stock desde ItemUbicacion
        const ubicacionItem = await getItemUbicacionFilterByUbicacion(selectedItem.id, selectedUbicacion.id)
        console.log(ubicacionItem)

        // Usar el precio de lista desde ListaDeMontos (reemplaza itemEntidad deprecado)
        const costoProveedor = precioListaItem ? precioListaItem.monto : 0

        const stockDisponible = ubicacionItem?.length ? ubicacionItem[0]?.inventario : "No disponible"

        // Verificar si hay datos válidos
        if (stockDisponible === "No disponible" || costoProveedor === "No disponible") {
          MySwal.fire({
            icon: "error",
            title: "Error",
            text: "Producto no encontrado en esta ubicación",
          })
          return
        }

        // Verificar si el ítem ya existe en itemList
        const existingItemIndex = itemList.findIndex(
          (it) => it.idItem === selectedItem.id && it.idUbicacion === selectedUbicacion.id,
        )

        if (existingItemIndex !== -1) {
          // Si el ítem existe, actualiza su cantidad
          await handleUpdateItemPorCantidad(
            existingItemIndex,
            Number(itemList[existingItemIndex].cantidad) + 1,
          )
        } else {
          // Crear el nuevo ítem con cantidad 1 por defecto
          const newItem = {
            descripcion: selectedItem.descripcion,
            cantidad: 1, // Cantidad por defecto 1
            stock: stockDisponible,
            costo: costoProveedor,
            codigo: selectedItem.codigo,
            porcentajeDescuento: 0,
            idItem: selectedItem.id,
            precio: costoProveedor,
            idUbicacion: selectedUbicacion.id,
            ubicacion: selectedUbicacion.label,
          }

          console.log(newItem)

          const updatedItems = [newItem, ...itemList] // Agregar al principio como en los otros componentes

          // Recalcular precio total
          const updatedTotal = updatedItems.reduce(
            (total, item) => total + (item.precio !== null ? item.cantidad * item.costo : 0),
            0,
          )

          // Recalcular cantidad total de ítems seleccionados
          const updatedCantidadItem = updatedItems.reduce((cantidadItems, item) => cantidadItems + item.cantidad, 0)

          setPrecioTotal(updatedTotal)
          setCantidadItemsSelect(updatedCantidadItem)
          setItemList(updatedItems)
          setCantidadItemsInvocados(updatedItems.length)
        }

        // Resetea los campos
        setSelectedItem(null)
        if (autocompleteRef.current) {
          autocompleteRef.current.focus()
        }
      }
    } catch (error) {
      if (error.response) {
        console.error("Error en la respuesta del servidor:", error.response.data)
      } else if (error.request) {
        console.error("Error en la solicitud:", error.request)
      } else {
        console.error("Error en la configuración:", error.message)
      }
    }
  }

  const handleUpdateItemPorCantidad = async (index, newCantidad) => {
    try {
      const updatedItems = await Promise.all(
        itemList.map(async (it, i) => {
          if (i === index) {
            return {
              ...it,
              cantidad: Number(newCantidad),
            }
          }
          return it
        }),
      )
      setItemList(updatedItems)
    } catch (error) {
      console.error("Error actualizando el item:", error)
    }
  }

  // Función para actualizar totales
  const updateTotals = (items) => {
    const updatedTotal = items.reduce(
      (total, item) => total + item.cantidad * item.costo,
      0
    );
    setPrecioTotal(updatedTotal);
  };

  const handleUpdateItemPorCosto = async (index, newCosto) => {
    try {
      // Validar y limpiar el costo
      const costoNumerico = parseFloat(newCosto);
      if (isNaN(costoNumerico) || costoNumerico <= 0) {
        MySwal.fire({
          icon: "error",
          title: "Error",
          text: "El costo debe ser un número válido mayor a 0",
        });
        // Restaurar el costo anterior
        const currentItem = itemList[index];
        if (currentItem) {
          // Forzar actualización del campo de input
          const costInput = document.querySelector(`input[defaultvalue="${currentItem.costo}"]`);
          if (costInput) {
            costInput.value = currentItem.costo;
          }
        }
        return;
      }

      const updatedItems = await Promise.all(
        itemList.map(async (it, i) => {
          if (i === index) {
            return {
              ...it,
              costo: costoNumerico,
              precio: costoNumerico, // Actualizar también el precio para mantener consistencia
            }
          }
          return it
        }),
      )
      setItemList(updatedItems)
      
      // Recalcular totales después de actualizar el costo
      updateTotals(updatedItems);
      
      // No mostrar mensaje por cada actualización individual
    } catch (error) {
      console.error("Error actualizando el item:", error)
      MySwal.fire({
        icon: "error",
        title: "Error",
        text: "Error al actualizar el costo",
      });
    }
  }

  // Eliminar ítem individual
  const handleDeleteItem = (index) => {
    const itemToRemove = itemList[index]
    setPrecioTotal((prevTotal) => prevTotal - itemToRemove.cantidad * itemToRemove.costo)
    setCantidadItemsSelect((prevCantidad) => prevCantidad - itemToRemove.cantidad)
    setCantidadItemsInvocados((prevSelect) => prevSelect - 1)
    setItemList(itemList.filter((_, i) => i !== index))
  }

  // Eliminar todos los ítems
  const handleDeleteAllItems = () => {
    setItemList([])
    setPrecioTotal(0)
    setCantidadItemsSelect(0)
    setCantidadItemsInvocados(0)
  }

  // Función que maneja cuando se abre el modal de creación de cliente
  const handleAbrirModalCrearCliente = () => {
    setAbrirModalEntidadCliente(false)
    setAbrirModalCrearCliente(true)
    setIsEditing(false)
  }

  // Función que se ejecutará cuando se cree correctamente la entidad
  const handleCerrarModalCrearCliente = () => {
    setAbrirModalCrearCliente(false)
  }

  const abrirModificarCliente = (entidad) => {
    setEntidadAEditar(entidad)
    setIsEditing(true)
    setAbrirModalCrearCliente(true)
  }

  // Función para verificar proveedor
  const controlarProveedorIngresadoSiExiste = () => {
    if (dniProveedor) {
      setEntidadExistente(dniProveedor)
      setAbrirModalEntidadCliente(true)
    } else {
      setEntidadExistente(null)
      setAbrirModalEntidadCliente(true)
    }
  }

  // Función para manejar cuando se crea un nuevo proveedor
  const handleProveedorCreado = (proveedorData) => {
    // Autocompletar el campo proveedor con el nuevo proveedor creado
    setDniProveedor(proveedorData)
    
    // Actualizar la lista de entidades para que aparezca el nuevo proveedor
    getEntidadesClientesTresLetras("", 2) // 2 para proveedores
    
    console.log("Proveedor creado y autocompletado:", proveedorData)
  }

  // Función para manejar alertas
  const handleAlerta = (success) => {
    if (success) {
      MySwal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "Operación realizada correctamente",
        confirmButtonText: "OK"
      })
    } else {
      MySwal.fire({
        icon: "error", 
        title: "Error",
        text: "Hubo un problema al realizar la operación",
        confirmButtonText: "OK"
      })
    }
  }

  const handleCloseModalMedioPago = () => {
    setOpenModalMedioPago(false)
  }

  const autocompleteRef = useRef(null)
  const buttonRef = useRef(null)

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault() // Evitar el comportamiento por defecto de Enter

      // Si hay un item seleccionado, agregarlo automáticamente
      if (selectedItem && document.activeElement !== buttonRef.current) {
        handleAddItem()
        return
      }

      if (document.activeElement === buttonRef.current) {
        // Si el botón está enfocado, volver al Autocomplete
        autocompleteRef.current.focus()
      } else {
        // Si no está en el botón, pasar al botón
        buttonRef.current.focus()
      }
    }
  }

  const handleKeyDownAndSubmit = (event) => {
    handleKeyDown(event)
    if (event.key === "Enter") {
      handleAddItem()
    }
  }

  // Mostrar spinner mientras se cargan los datos precargados
  if (isLoadingPreloadedData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <SpinnerLading />
        <Typography variant="body1" color="text.secondary">
          Cargando datos del inventario...
        </Typography>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#f5f5f5",
        position: "relative",
        padding: 2,
      }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleTransaccionSubmit()
        }}
      >
        <Grid container spacing={2}>
          {/* Left Column - Products */}
          <Grid item xs={12} md={9}>
            <Card elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                  <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Generar Compra
                </Typography>
                
                <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1, p: 1, borderRadius: 1 }}>
                  {/* Selector de proveedor */}
                  <Autocomplete
                    size="small"
                    fullWidth
                    disablePortal
                    options={entidadesTipoEntidad.map((it) => ({
                      label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
                      descripcion: it.descripcion,
                      apellido: it.apellido,
                      id: it.id,
                      dniCuitCuil: it.dniCuitCuil,
                    }))}
                    value={dniProveedor}
                    onChange={handleProveedorSeleccionado}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Proveedor - DNI / CUIT / CUIL"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <PersonIcon color="action" sx={{ ml: 1, mr: 0.5 }} />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                  <Tooltip title="Verificar Proveedor">
                    <IconButton
                      onClick={controlarProveedorIngresadoSiExiste}
                      sx={{ color: "rgb(244, 177, 14)" }}
                    >
                      <PersonAddAltIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    gap: 1,
                    backgroundColor: alpha("#f5f5f5", 0.5),
                    p: 1,
                    borderRadius: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={(itemTresLetras || []).map((it) => ({
                      label: `${it.codigo} - ${it.descripcion}`,
                      descripcion: it.descripcion,
                      codigo: it.codigo,
                      id: it.id,
                    }))}
                    value={selectedItem}
                    onChange={async (event, newValue) => {
                      setSelectedItem(newValue)
                      // Agregar automáticamente cuando se selecciona un item
                      if (newValue && proveedorSeleccionado) {
                        // Pequeño delay para permitir que el estado se actualice
                        setTimeout(async () => {
                          await handleAddItem()
                        }, 100)
                      }
                    }}
                    onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
                    disabled={!proveedorSeleccionado}
                    sx={{ flexGrow: 1 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar producto"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <SearchIcon color="action" sx={{ ml: 1, mr: 0.5 }} />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        inputRef={autocompleteRef}
                        onKeyDown={handleKeyDown}
                      />
                    )}
                  />
                      <Button
                    variant="contained"
                    onClick={handleAddItem}
                    ref={buttonRef}
                    onKeyDown={handleKeyDownAndSubmit}
                    startIcon={<AddShoppingCartIcon />}
                    disabled={!proveedorSeleccionado}
                    sx={{ backgroundColor: "#5b5b5f", color: "white" }}
                  >
                    Agregar
                  </Button>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Autocomplete
                      size="small"
                      disablePortal
                      options={ubicaciones.map((it) => ({
                        id: it.id,
                        label: it.descripcion,
                      }))}
                      value={selectedUbicacion}
                      onChange={(event, newValue) => {
                        setSelectedUbicacion(newValue)
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Ubicación" size="small" sx={{ width: 150 }} />
                      )}
                    />
                    <Autocomplete
                      size="small"
                      disablePortal
                      options={negocios.map((it) => ({
                        id: it.id,
                        label: it.descripcion,
                      }))}
                      value={selectedNegocio}
                      onChange={(event, newValue) => {
                        setSelectedNegocio(newValue)
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Negocio" size="small" sx={{ width: 150 }} />
                      )}
                    />
                  </Box>
              
                </Box>
              </CardContent>
            </Card>

            <Card elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
              <TableContainer
                sx={{
                  maxHeight: {
                    xs: "calc(100vh - 300px)", // En móviles, usa toda la altura menos espacio para otros elementos
                    md: "calc(100vh - 250px)", // En desktop, usa toda la altura menos espacio para otros elementos
                  },
                  overflowX: "auto",
                  overflowY: "auto", // Asegura que aparezca scroll vertical cuando sea necesario
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Producto</StyledTableCell>
                      <StyledTableCell align="right">Cantidad</StyledTableCell>
                      <StyledTableCell align="right">Stock</StyledTableCell>
                      <StyledTableCell align="right">Costo Unit.</StyledTableCell>
                      <StyledTableCell align="right">Total</StyledTableCell>
                      <StyledTableCell align="center">Acciones</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itemList.length > 0 ? (
                      itemList.map((it, index) => (
                        <StyledTableRow key={index}>
                          <TableCell>
                            <Typography variant="body2" fontWeight="medium">
                              {it.codigo} - {it.descripcion}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <TextField
                              type="number"
                              defaultValue={it.cantidad || 0}
                              size="small"
                              onBlur={(e) => handleUpdateItemPorCantidad(index, e.target.value)}
                              sx={{
                                width: 80,
                                "& .MuiInputBase-root": {
                                  borderRadius: 1,
                                },
                              }}
                              InputProps={{
                                endAdornment:
                                  it.cantidad > it.stock ? (
                                    <Tooltip title="Cantidad mayor a stock">
                                      <ErrorOutlineIcon sx={{ color: red[500], cursor: "pointer" }} />
                                    </Tooltip>
                                  ) : null,
                              }}
                            />
                          </TableCell>
                          <TableCell align="right">{it.stock}</TableCell>
                          <TableCell align="right">
                            <TextField
                              type="number"
                              defaultValue={it.costo || 0}
                              size="small"
                              onBlur={(e) => handleUpdateItemPorCosto(index, e.target.value)}
                              sx={{
                                width: 100,
                                "& .MuiInputBase-root": {
                                  borderRadius: 1,
                                },
                              }}
                              InputProps={{ 
                                startAdornment: <span>$</span>,
                                inputProps: { 
                                  step: "any", //permite decimales
                                  min: 0
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <Typography fontWeight="medium">
                              {new Intl.NumberFormat("es-AR", {
                                style: "currency",
                                currency: "ARS",
                              }).format(it.costo * it.cantidad)}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton color="error" size="small" onClick={() => handleDeleteItem(index)}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                          <Typography variant="body1" color="text.secondary">
                            No hay productos agregados
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Busque y agregue productos para comenzar la compra
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell colSpan={6} align="right">
                        <Button
                          variant="outlined"
                          color="error"
                          startIcon={<DeleteIcon />}
                          onClick={handleDeleteAllItems}
                          disabled={itemList.length === 0}
                          sx={{ mt: 1, mb: 1 }}
                        >
                          Eliminar todos
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>

            {itemList.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                  p: 2,
                  bgcolor: "white",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="#5b5b5f">
                    ITEMS:
                  </Typography>
                  <Typography variant="subtitle1" fontWeight="bold" color="rgb(244, 177, 14)">
                    {itemList.length}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="#5b5b5f">
                    CANTIDAD ITEMS:
                  </Typography>
                  <Typography variant="subtitle1" fontWeight="bold" color="rgb(244, 177, 14)">
                    {itemList.reduce((total, item) => total + item.cantidad, 0)}
                  </Typography>
                </Box>
              </Box>
            )}
          </Grid>

          {/* Right Column - Summary and Actions */}
          <Grid item xs={12} md={3}>
            <Card elevation={3} sx={{ borderRadius: 2, mb: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                  <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Resumen de Compra
                </Typography>

                <Box
                  sx={{
                    backgroundColor: alpha("#f5f5f5", 0.5),
                    p: 2,
                    borderRadius: 1,
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Typography variant="body1">Subtotal:</Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(precioTotal)}
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 1 }} />

                  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                    <Typography variant="h6">TOTAL:</Typography>
                    <Typography variant="h6" color="rgb(244, 177, 14)" fontWeight="bold">
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(precioTotal)}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, display: "flex", alignItems: "center" }}>
                    <PaymentIcon sx={{ mr: 1, fontSize: "small", color: "rgb(244, 177, 14)" }} />
                    Medio de Pago
                  </Typography>

                  <Autocomplete
                    size="small"
                    disablePortal
                    options={tipoMedioDePago || []}
                    getOptionLabel={(option) => option.descripcion}
                    value={selectedTipoMedioDePago}
                    onChange={(event, newValue) => {
                      setSelectedTipoMedioDePago(newValue)
                    }}
                    renderInput={(params) => <TextField {...params} label="Tipo de medio de pago" fullWidth />}
                    sx={{ mb: 1 }}
                  />

                  {mostrarButtonModalMedioPago && (
                    <Button
                      variant="outlined"
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={handleAbrirModalMedioDePago}
                      fullWidth
                      sx={{ mt: 1 }}
                    >
                      Agregar Medio de Pago
                    </Button>
                  )}

                  <Collapse in={openCollapse}>
                    <Box sx={{ mt: 1 }}>
                      <Autocomplete
                        size="small"
                        disablePortal
                        options={medioDePagoIdTipoEspecifico || []}
                        getOptionLabel={(option) => option.descripcion}
                        value={selectedMedioDePago}
                        onChange={(event, newValue) => {
                          setSelectedMedioDePago(newValue)
                        }}
                        renderInput={(params) => <TextField {...params} label="Medio de pago" fullWidth />}
                      />
                    </Box>
                  </Collapse>
                </Box>

                <Button
                  variant="contained"
                  type="submit"
                  fullWidth
                  size="large"
                  startIcon={<ReceiptIcon />}
                  disabled={itemList.length === 0 || !dniProveedor} // Solo requiere items y proveedor
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    fontWeight: "bold",
                    boxShadow: 3,
                    backgroundColor: "#5b5b5f",
                    color: "white",
                  }}
                >
                  GENERAR COMPRA
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  fullWidth
                  size="large"
                  startIcon={<DeleteIcon />}
                  onClick={handleDeleteAllItems}
                  sx={{
                    mt: 2,
                    py: 1.5,
                    borderRadius: 2,
                    fontWeight: "bold",
                  }}
                >
                  ELIMINAR ÍTEMS
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </form>

      {/* Modal de Medio de Pago */}
      <Modal open={openModalMedioPago} onClose={handleCloseModalMedioPago}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 480,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <IconButton
            onClick={handleCloseModalMedioPago}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "grey.500",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="h2" sx={{ textAlign: "center", color: "primary.main", mb: 2 }}>
            Selección de Medio de Pago
          </Typography>
          <Divider sx={{ mb: 3 }} />

          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Autocomplete
              size="small"
              disablePortal
              options={tipoMedioDePago || []}
              getOptionLabel={(option) => option.descripcion}
              value={modalTipoMedioDePagoSeleccionado}
              onChange={(event, newValue) => setModalTipoMedioDePagoSeleccionado(newValue)}
              sx={{ width: "100%" }}
              renderInput={(params) => <TextField {...params} label="Tipo de medio de pago" />}
            />

            <Autocomplete
              size="small"
              disablePortal
              options={(medioDePagoIdTipoEspecifico || []).map((it) => ({
                label: it.descripcion,
                id: it.id,
              }))}
              onChange={(event, newValue) => {
                if (newValue) {
                  setModalMedioDePagoSeleccionado(newValue.label)
                  setModalMedioDePagoSeleccionadoID(newValue.id)
                } else {
                  setModalMedioDePagoSeleccionado(null)
                  setModalMedioDePagoSeleccionadoID(null)
                }
              }}
              sx={{ width: "100%" }}
              renderInput={(params) => <TextField {...params} label="Medio de Pago" />}
            />
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              label="Cantidad a pagar"
              variant="outlined"
              sx={{ flexGrow: 1 }}
              value={modalMedioDePagoCantidad}
              onChange={(e) => setModalMedioDePagoCantidad(e.target.value)}
            />
            <IconButton onClick={handleAddNuevoMedioDePago} color="primary" sx={{ color: "rgb(244, 177, 14)" }}>
              <AddCircleOutlineIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              backgroundColor: "#f9f9f9",
              borderRadius: 2,
              padding: 2,
              boxShadow: 1,
              mt: 3,
            }}
          >
            <Stack spacing={2}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle1" fontWeight="bold">
                  TOTAL
                </Typography>
                <Typography variant="subtitle1">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(precioTotal)}
                </Typography>
              </Box>

              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle1" fontWeight="bold">
                  CANTIDAD POR PAGOS
                </Typography>
                <Typography variant="subtitle1">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(cantidaMedioDePagoList)}
                </Typography>
              </Box>

              <Divider sx={{ my: 1 }} />

              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle1" fontWeight="bold">
                  RESTANTE
                </Typography>
                <Typography
                  variant="body2"
                  color={precioTotal === cantidaMedioDePagoList ? "success.main" : "text.secondary"}
                  textAlign="center"
                >
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(precioTotal - cantidaMedioDePagoList)}
                </Typography>
              </Box>
            </Stack>
          </Box>

          {precioTotal !== cantidaMedioDePagoList && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: "center" }}>
              Nota: Se permite realizar pagos parciales en esta transacción.
            </Typography>
          )}

          <Typography
            variant="subtitle1"
            sx={{
              mt: 2,
              mb: 1,
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            Lista de Medios de Pago Seleccionados
          </Typography>
          <Box
            sx={{
              maxHeight: 150,
              overflowY: "auto",
              backgroundColor: "#fafafa",
              padding: 2,
              borderRadius: 1,
            }}
          >
            {medioDePagoList.map((it, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  mb: 1,
                  p: 1,
                  backgroundColor: "#f0f0f0",
                  borderRadius: 1,
                }}
              >
                <Typography variant="body2">{it.descripcion}</Typography>
                <Typography variant="body2">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(it.monto)}
                </Typography>

                <IconButton
                  edge="end"
                  onClick={() => handleDeleteMedioDePago(index, it.monto)}
                  sx={{ color: "rgb(244, 177, 14)" }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>

      {/* Modal de Factura */}
      {openModal && (
        <ModalFacturaComponent
          open={openModal}
          handleClose={handleCloseModal}
          transaccionData={transaccionData}
          itemsTransaccion={itemsTransaccion}
          entidadParaFactura={entidadFactura}
          usuarioParaFactura={null}
          tipoDeFactura={true}
          deDondeViene={"compra"}
        />
      )}

      {/* Modales de Entidad */}
      <ModalEntidadCliente
        open={abrirModalEntidadCliente}
        handleClose={() => setAbrirModalEntidadCliente(false)}
        esClienteExistente={!!entidadExistente}
        entidad={entidadExistente}
        abrirCrearCliente={handleAbrirModalCrearCliente}
        abrirModificarCliente={abrirModificarCliente}
        deDondeViene="COMPRA"
        tipoEntidad="proveedor"
      />

      <CrearEntidadClienteModalComponent
        open={abrirModalCrearCliente}
        handleClose={handleCerrarModalCrearCliente}
        entidad={entidadAEditar}
        isEditing={isEditing}
        handleAlerta={handleAlerta}
        onClienteCreado={handleProveedorCreado}
        tipoEntidad="proveedor"
      />
    </Box>
  )
}

export default GestionGenerarCompraComponent

